<template>
    <div>
        <b-modal :id="id" centered hide-footer hide-header :visible="visible" body-class="adicionar-perfil-sub-body" @hidden="$emit('close')">
            <div class="mt-4"></div>
            <slot/>      
            <div class="mt-4 mb-2">
                <b-button pill class="btn-base primary-btn btn-modal" @click=" id ? $bvModal.hide(id) : $emit('close')">Ok</b-button>
            </div>
        </b-modal>
    </div>	
</template>

<script>


export default {
	name: "ModalAlert",
    props:{
        id: String,
        visible: Boolean
    }
}
</script>

<style>
.modal-content {
    border-radius: 0.8rem !important;
    border: none !important;
}
.modal-body {
    padding: 5% !important;
    letter-spacing: 0 !important;
    font-family: optum-sans !important;
    font-weight: 400 !important;
    color: rgb(90, 90, 90) !important;
    font-size: 0.895rem !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: left;
}

html body .btn-modal {
    font-size: 16px !important;
    padding: 8px 20px !important;
}

.adicionar-perfil-sub-header{
    padding-bottom: 5px !important;
}

.adicionar-perfil-sub-body{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 0px !important;
    text-align: center;
}

.icon-modal-alert-error{
    color: #E32315;
    font-size: 53px;
    margin-bottom: 15px;
}

.icon-modal-alert-success{
    color: #627D32;
    font-size: 53px;
    margin-bottom: 15px;
}

.close {
   color: #002677 !important;
   opacity: 1 !important;
   margin-right: 2px !important;

}
</style>